/* Version: 3.5.137 */
'use client';
import styled from 'styled-components';
import LANG from '../../lang/lang.js';
import { BREAKPOINTS } from '../../spacing/index.js';
import { rem } from '../../utils/functions.js';
import { typography } from '../../typography/typography.js';

var FooterWrapper = /*#__PURE__*/styled.footer.withConfig({
  displayName: "styledComponents__FooterWrapper",
  componentId: "sc-1mnzuyu-0"
})(["z-index:3;position:relative;bottom:0;left:0;right:0;width:100%;background-color:", ";color:", ";font-family:", ";font-size:", ";font-weight:", ";padding:0 40px 0;@media (max-width:", "px){padding:0 16px 0;}& a,button{text-decoration:none;}& .mux-Footer-icon{margin-left:5px;display:inline-flex;}"], function (_ref) {
  var theme = _ref.theme;
  return theme.colorPalette.neutralColors.dark.shade_default;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colorPalette.neutralColors.light.shade_dark_3;
}, typography.fontFamily, typography.fontSizeSmall, typography.fontWeightNormal, BREAKPOINTS.TABLET_PORTRAIT);
process.env.NODE_ENV !== "production" ? FooterWrapper.displayName = 'FooterWrapper' : undefined;
var QuickLinksSection = /*#__PURE__*/styled.div.withConfig({
  displayName: "styledComponents__QuickLinksSection",
  componentId: "sc-1mnzuyu-1"
})(["padding:20px 0;border-bottom:", ";& .mux-Footer-accordion-header span{height:20px;width:20px;margin-right:12px;}"], function (_ref3) {
  var theme = _ref3.theme;
  return "1px solid ".concat(theme.colorPalette.neutralColors.dark.shade_light_1);
});
process.env.NODE_ENV !== "production" ? QuickLinksSection.displayName = 'QuickLinksSection' : undefined;
var QuickLinksHeader = /*#__PURE__*/styled.div.withConfig({
  displayName: "styledComponents__QuickLinksHeader",
  componentId: "sc-1mnzuyu-2"
})(["font-weight:", ";color:", ";text-transform:uppercase;"], typography.fontWeightBold, function (_ref4) {
  var theme = _ref4.theme;
  return theme.colorPalette.neutralColors.light.shade_dark_3;
});
process.env.NODE_ENV !== "production" ? QuickLinksHeader.displayName = 'QuickLinksHeader' : undefined;
var QuickLinksAccordionHeader = /*#__PURE__*/styled.button.withConfig({
  displayName: "styledComponents__QuickLinksAccordionHeader",
  componentId: "sc-1mnzuyu-3"
})(["display:flex;align-items:center;font-family:", ";font-weight:", ";color:", ";text-transform:uppercase;background:transparent;border:none;padding:0;"], typography.fontFamily, typography.fontWeightBold, function (_ref5) {
  var theme = _ref5.theme;
  return theme.colorPalette.neutralColors.light.shade_dark_3;
});
process.env.NODE_ENV !== "production" ? QuickLinksAccordionHeader.displayName = 'QuickLinksAccordionHeader' : undefined;
var QuickLinksList = /*#__PURE__*/styled.ul.withConfig({
  displayName: "styledComponents__QuickLinksList",
  componentId: "sc-1mnzuyu-4"
})(["display:flex;margin:0;padding:0;list-style:none;@media screen and (max-width:", "px){flex-direction:column;padding-left:32px;}li{margin-right:40px;margin-top:14px;}"], BREAKPOINTS.TABLET_PORTRAIT);
process.env.NODE_ENV !== "production" ? QuickLinksList.displayName = 'QuickLinksList' : undefined;
var SiteLinksSection = /*#__PURE__*/styled.div.withConfig({
  displayName: "styledComponents__SiteLinksSection",
  componentId: "sc-1mnzuyu-5"
})(["display:flex;padding:20px 0;border-bottom:", ";@media (max-width:", "px){flex-direction:column;}"], function (_ref6) {
  var theme = _ref6.theme;
  return "1px solid ".concat(theme.colorPalette.neutralColors.dark.shade_light_1);
}, BREAKPOINTS.DESKTOP_MED);
process.env.NODE_ENV !== "production" ? SiteLinksSection.displayName = 'SiteLinksSection' : undefined;
var SiteLinksList = /*#__PURE__*/styled.ul.withConfig({
  displayName: "styledComponents__SiteLinksList",
  componentId: "sc-1mnzuyu-6"
})(["display:flex;margin:0;padding:0;list-style:none;@media (max-width:", "px){flex-wrap:wrap;}li{margin-right:40px;@media (max-width:", "px){width:50%;margin:0 0 14px;&:last-of-type{margin:0px;}}", "}"], BREAKPOINTS.TABLET_PORTRAIT, BREAKPOINTS.TABLET_PORTRAIT, function (_ref7) {
  var lang = _ref7.lang;
  return lang === LANG.FR_CA && "@media (max-width: ".concat(BREAKPOINTS.TABLET_PORTRAIT, "px) {\n        width: 100%;\n      }");
});
process.env.NODE_ENV !== "production" ? SiteLinksList.displayName = 'SiteLinksList' : undefined;
var SocialMediaLinksList = /*#__PURE__*/styled.ul.withConfig({
  displayName: "styledComponents__SocialMediaLinksList",
  componentId: "sc-1mnzuyu-7"
})(["display:flex;margin:0;padding:0;list-style:none;@media (max-width:", "px){margin-top:40px;}a,button{display:flex;color:", ";background:transparent;border:none;padding:0;margin-right:24px;:hover,:focus{color:", ";}}"], BREAKPOINTS.DESKTOP_MED, function (_ref8) {
  var theme = _ref8.theme;
  return theme.colorPalette.neutralColors.light.shade_dark_3;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.colorPalette.neutralColors.light.shade_white;
});
process.env.NODE_ENV !== "production" ? SocialMediaLinksList.displayName = 'SocialMediaLinksList' : undefined;
var LegalSection = /*#__PURE__*/styled.div.withConfig({
  displayName: "styledComponents__LegalSection",
  componentId: "sc-1mnzuyu-8"
})(["display:flex;padding:20px 0 40px;font-weight:", ";color:", ";& .mux-Footer-copyright{margin-left:14px;}& .mux-Footer-legal{font-size:", ";line-height:", ";}&[data-haslegal='true']{flex-direction:column;align-items:flex-start;& .mux-Footer-copyright{margin:14px 0 20px;}}@media (max-width:", "px){flex-direction:column;align-items:flex-start;& .mux-Footer-copyright{margin:14px 0 0;}}"], typography.fontWeightLight, function (_ref10) {
  var theme = _ref10.theme;
  return theme.colorPalette.neutralColors.light.shade_white;
}, rem(12), rem(18), BREAKPOINTS.TABLET_PORTRAIT);
process.env.NODE_ENV !== "production" ? LegalSection.displayName = 'LegalSection' : undefined;

export { FooterWrapper, LegalSection, QuickLinksAccordionHeader, QuickLinksHeader, QuickLinksList, QuickLinksSection, SiteLinksList, SiteLinksSection, SocialMediaLinksList };
